const tramites = [
  {
    idTramite: 'arba-tasa-catastral',
    idFormulario: 'tasa-catastral',
    organismo: 'ARBA',
    destinatario: 'ORGANISMO',
    nombre: 'ARBA - Tasa catastral',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'rpba-inscripciones',
    idFormulario: 'formulario-a',
    organismo: 'RPBA',
    destinatario: 'PROFESIONAL',
    nombre: 'RPBA - Inscripciones',
    titulo: 'Trámites presenciales para inscripción de documentos',
    descripcion:
      'Una vez abonado se debe concurrir con el comprobante para cambiar por un timbrado en las cajas del RPBA',
    observaciones: 'Obtener un comprobante por oblea requerida',
  },
  {
    idTramite: 'rpba-publicidad',
    idFormulario: 'formulario-b',
    organismo: 'RPBA',
    destinatario: 'PROFESIONAL',
    nombre: 'RPBA - Publicidad web carga de saldo',
    titulo: 'Publicidad web con firma digital',
    descripcion: 'Para incremento de saldo en la cuenta de usuario suscripto',
    observaciones: '',
  },
  {
    idTramite: 'rpba-medidas-cautelares',
    idFormulario: 'formulario-b',
    organismo: 'RPBA',
    destinatario: 'PROFESIONAL',
    nombre: 'RPBA - Medidas cautelares web - Uso judicial',
    titulo: 'Medidas cautelares de juzgados de la Provincia de Buenos Aires - DTR 8/19',
    descripcion: 'Tildar la opción "Para uso judicial" y completar los datos que se despliegan',
    observaciones: '',
  },
  {
    idTramite: 'rpba-publicidad-organismos',
    idFormulario: 'formulario-d',
    organismo: 'RPBA',
    destinatario: 'ORGANISMO',
    nombre: 'RPBA - Publicidad web',
    titulo: 'Organismos y Municipios con "Tasa especial"',
    descripcion: 'Para cancelar la liquidación realizada por el sector "Trámites Especiales"',
    observaciones: '',
  },
  {
    idTramite: 'rpba-medidas-cautelares-judicial',
    idFormulario: 'formulario-d',
    organismo: 'RPBA',
    destinatario: 'ORGANISMO',
    nombre: 'RPBA - Medidas cautelares web',
    titulo: 'Organismos y Municipios con convenios de "Tasas sujetas a recupero" vigentes',
    descripcion: 'Tildar la opción "Para uso judicial" y completar los datos que se despliegan',
    observaciones: '',
  },
  {
    idTramite: 'colescba-cuenta-notarial',
    idFormulario: 'cuenta-notarial',
    organismo: 'COLESCBA',
    destinatario: 'PROFESIONAL',
    nombre: 'COLESCBA - Comprobante para carga de saldo en cuenta notarial',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'colescba-terceros',
    idFormulario: 'tasas-varias',
    organismo: 'COLESCBA',
    destinatario: 'PROFESIONAL',
    nombre: 'COLESCBA - Comprobante de tasas varias',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'colescba-testamentos',
    idFormulario: 'informe-testamentos',
    organismo: 'COLESCBA',
    destinatario: 'PROFESIONAL',
    nombre: 'COLESCBA - Comprobante para solicitud de informes de testamento',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'colescba-honorarios',
    idFormulario: 'honorarios-judiciales',
    organismo: 'COLESCBA',
    destinatario: 'PROFESIONAL',
    nombre: 'COLESCBA - Comprobante de aportes por Honorarios Judiciales',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'dppj-comprobante',
    idFormulario: 'dppj-comprobante',
    organismo: 'DPPJ',
    destinatario: 'PROFESIONAL',
    nombre: 'Comprobantes de DPPJ',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'dppj-comprobante-cambio-plazo',
    idFormulario: 'dppj-comprobante-cambio-plazo',
    organismo: 'DPPJ',
    destinatario: 'PROFESIONAL',
    nombre: 'Comprobantes de DPPJ - Cambio de Plazo',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'dppj-comprobante-diferencia',
    idFormulario: 'dppj-comprobante-diferencia',
    organismo: 'DPPJ',
    destinatario: 'PROFESIONAL',
    nombre: 'Comprobantes de DPPJ - Diferencia',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },
  {
    idTramite: 'dppj-comprobante-traslado',
    idFormulario: 'dppj-comprobante-traslado',
    organismo: 'DPPJ',
    destinatario: 'PROFESIONAL',
    nombre: 'Comprobantes de DPPJ - Traslado',
    titulo: '',
    descripcion: '',
    observaciones: '',
  },

  {
    idTramite: 'caja-planes-pagos-varios',
    idFormulario: 'caja-form',
    organismo: 'CAJA',
    destinatario: 'PROFESIONAL',
    nombre: 'CSS - Planes de pagos varios',
    titulo: '',
    descripcion: '',
    observaciones: '',
    categoriaDeudaId: 'CSSPP',
  },
  {
    idTramite: 'caja-prestamos',
    idFormulario: 'caja-form',
    organismo: 'CAJA',
    destinatario: 'PROFESIONAL',
    nombre: 'CSS - Préstamos',
    titulo: '',
    descripcion: '',
    observaciones: '',
    categoriaDeudaId: 'PREST',
  },
  {
    idTramite: 'caja-salud',
    idFormulario: 'caja-form',
    organismo: 'CAJA',
    destinatario: 'PROFESIONAL',
    nombre: 'CSS - Salud',
    titulo: '',
    descripcion: '',
    observaciones: '',
    categoriaDeudaId: 'SALUD',
  },
  {
    idTramite: 'caja-pagos-cuenta',
    idFormulario: 'caja-form',
    organismo: 'CAJA',
    destinatario: 'PROFESIONAL',
    nombre: 'CSS - Pagos a cuenta',
    titulo: '',
    descripcion: '',
    observaciones: '',
    categoriaDeudaId: 'CSSPCTA',
  },
  {
    idTramite: 'caja-fondo-distributivo',
    idFormulario: 'caja-form',
    organismo: 'CAJA',
    destinatario: 'PROFESIONAL',
    nombre: 'CSS - Fondo distributivo',
    titulo: '',
    descripcion: '',
    observaciones: '',
    categoriaDeudaId: 'CSSFD',
  },
]

const formularios = [
  {
    idFormulario: 'caja-form',
    formCaja: {
      nro_comprobante: null,
      descripcion: null,
      fecha_vencimiento: null,
      monto: null,
    },
    nombre: 'Comprobante de Caja',
    categoriaId: null,
    tipoDeuda: null,
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia.Bs.As-tasas Reg. y Cat."',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    roles: ['NOTARIO'],
    component: () => import('@/components/Formularios/CajaVarios/FormCajaStep'),
  },
  {
    idFormulario: 'tasa-catastral',
    tipo: '752',
    nombre: 'Tasa catastral',
    descripcion: null,
    tipoDeuda: 'TCAT',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia.Bs.As-tasas Reg. y Cat."',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/752/FormTasaCatastralStep'),
  },
  {
    idFormulario: 'formulario-b',
    tipo: '755',
    nombre: 'Formulario B',
    descripcion:
      'Trámites web no presenciales, generan timbrado sin oblea. Para incremento de saldo en la cuenta de crédito del RPBA.',
    tipoDeuda: 'RPPW',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia.Bs.As-tasas Reg. y Cat."',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/755/FormularioBStep'),
  },
  {
    idFormulario: 'formulario-d',
    tipo: '756',
    nombre: 'Formulario D',
    descripcion:
      'Trámites web no presenciales, generan timbrado sin oblea. Para incremento de saldo en la cuenta de crédito del RPBA, para convenios especiales.',
    tipoDeuda: 'RPPWC',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio ESCRIBANOS CONV LEY 10295"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/756/FormularioDStep'),
  },
  {
    idFormulario: 'formulario-a',
    tipo: '751',
    nombre: 'Formulario A',
    descripcion:
      'Trámites presenciales, generan oblea. Para inscripción de escribanos y/o abogados, publicidad.',
    otroDato: 'Importante: Generar un comprobante para cada timbrado requerido.',
    tipoDeuda: 'RPFA',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia.Bs.As-tasas Reg. y Cat."',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/751/FormularioAStep'),
  },
  {
    idFormulario: 'tasas-varias',
    tipo: '185',
    nombre: 'Comprobante de tasas varias',
    descripcion: null,
    tipoDeuda: 'CTER',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/185/FormTasasVariasStep'),
  },
  {
    idFormulario: 'cuenta-notarial',
    tipo: '180',
    nombre: 'Comprobante para carga de saldo en cuenta notarial',
    descripcion: null,
    tipoDeuda: 'CTANOT',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio ESCRIBANOS CONV LEY 10295"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escrib Conv Fondos"',
        campoCPE: '"Código Pagar"',
      },
    },
    private: true,
    roles: ['NOTARIO', 'JUBILADO_LEG'],
    component: () => import('@/components/Formularios/185/FormCuentaNotarialStep'),
  },
  {
    idFormulario: null,
    tipo: '185',
    nombre: 'Comprobante de tasas varias de Segundo Testimonio del AAN',
    descripcion: null,
    tipoDeuda: 'CTER_AANST',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/185/FormTasasVariasStep'),
  },
  {
    idFormulario: null,
    tipo: '185',
    nombre: 'Comprobante de tasas varias JNA',
    descripcion: null,
    tipoDeuda: 'CTER_JNA',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/185/FormTasasVariasStep'),
  },
  {
    idFormulario: null,
    tipo: '185',
    nombre: 'Comprobante de tasas varias JNB',
    descripcion: null,
    tipoDeuda: 'CTER_JNB',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/185/FormTasasVariasStep'),
  },
  {
    idFormulario: null,
    tipo: '185',
    nombre: 'Comprobante de tasas varias Copia Virtual',
    descripcion: null,
    tipoDeuda: 'CTER_CV',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/185/FormTasasVariasStep'),
  },
  {
    idFormulario: 'informe-testamentos',
    tipo: '181',
    nombre: 'Comprobante para solicitud de informes de testamento',
    descripcion: null,
    tipoDeuda: 'ITA',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/181/FormInformeTestamentosStep'),
  },
  {
    idFormulario: 'honorarios-judiciales',
    tipo: '160',
    nombre: 'Comprobante de aportes por Honorarios Judiciales',
    descripcion: null,
    tipoDeuda: 'HJ',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    private: true,
    roles: ['NOTARIO'],
    component: () => import('@/components/Formularios/160/FormHonorariosJudicialesStep'),
  },
  {
    idFormulario: 'dppj-comprobante',
    tipo: '170',
    nombre: 'Comprobantes de DPPJ',
    descripcion: null,
    tipoDeuda: 'DPPJ',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/170/FormDppjStep'),
  },
  {
    idFormulario: 'dppj-comprobante-diferencia',
    tipo: '170_DIF',
    nombre: 'Comprobantes de DPPJ - Diferencia',
    descripcion: null,
    tipoDeuda: 'DPPJ_DIF',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/170/FormDppjDiferenciaStep'),
  },
  {
    idFormulario: 'dppj-comprobante-cambio-plazo',
    tipo: '171',
    nombre: 'Comprobantes de DPPJ - Cambio de Plazo',
    descripcion: null,
    tipoDeuda: 'DPPJ_CP',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/171/FormDppjCambioPlazoStep'),
  },
  {
    idFormulario: 'dppj-comprobante-traslado',
    tipo: '172',
    nombre: 'Comprobantes de DPPJ - Traslado',
    descripcion: null,
    tipoDeuda: 'DPPJ_TRAS',
    pagoElectronico: {
      LINK: {
        rubro: '"Asociaciones y Clubes"',
        ente: '"Colegio de Escribanos Pcia Bs As - Venta de Materiales"',
        campoCPE: '"Código Link Pagos"',
      },
      BANELCO: {
        rubro: '"Clubes y Asociaciones"',
        ente: '"Col Escribanos Bs As"',
        campoCPE: '"Código Pagar"',
      },
    },
    component: () => import('@/components/Formularios/172/FormDppjTrasladoStep'),
  },
]

// initial state
const state = {
  saldo: null,
  formularios: formularios,
  tramites: tramites,
  sedes: {
    CAJERO: null,
  },
  estadosUso: [],
  estadosPago: [],
}

// mutations
const mutations = {
  setSaldo(state, saldo) {
    state.saldo = saldo
  },
  addSede(state, payload) {
    state.sedes[payload.rolCod] = payload.sede
  },
  setEstadosUso(state, estadosUso) {
    state.estadosUso = estadosUso
  },
  setEstadosPago(state, estadosPago) {
    state.estadosPago = estadosPago
  },
  updateCajaForm(state, data) {
    if (!state.formularios) {
      state.formularios = []
    }

    let formulario = state.formularios.find(f => f.idFormulario === 'caja-form')

    if (formulario) {
      formulario.tipoDeuda = data.deuda_tipo_id
      formulario.categoriaId = data.deuda_categoria_id
    } else {
      formulario = {
        idFormulario: 'caja-form',
        tipoDeuda: data.deuda_tipo_id,
        categoriaId: data.deuda_categoria_id,
        pagoElectronico: {
          LINK: {
            rubro: '"Asociaciones y Clubes"',
            ente: '"Colegio de Escribanos Pcia.Bs.As-tasas Reg. y Cat."',
            campoCPE: '"Código Link Pagos"',
          },
          BANELCO: {
            rubro: '"Clubes y Asociaciones"',
            ente: '"Col Escrib Conv Fondos"',
            campoCPE: '"Código Pagar"',
          },
        },
      }
      state.formularios.push(formulario)
    }
  },
}

const actions = {
  async actualizarSaldo({ commit }, { cuitCuil, portalPagos }) {
    const saldo = await portalPagos.getSaldo(cuitCuil)
    commit('setSaldo', saldo)
  },

  async addSedeParaRol({ commit }, { cuitCuil, rolCod, oficinaId, portalPagos }) {
    try {
      const sede = await portalPagos.getSedes(cuitCuil, {
        oficina_id: oficinaId,
      })
      commit('addSede', { rolCod, sede })
    } catch (e) {
      console.error(e)
    }
  },
  async addSedeCajero({ dispatch }, { cuitCuil, oficinaId, portalPagos }) {
    await dispatch('addSedeParaRol', { cuitCuil, rolCod: 'CAJERO', oficinaId, portalPagos })
  },
  async fetchEstadosUso({ commit }, { cuitCuil, portalPagos }) {
    const estadosUso = await portalPagos.getEstadosUso(cuitCuil)
    commit('setEstadosUso', estadosUso)
  },
  async fetchEstadosPago({ commit }, { cuitCuil, portalPagos }) {
    const estadosPago = await portalPagos.getEstadosPago(cuitCuil)
    commit('setEstadosPago', estadosPago)
  },
  async actualizarCajaForm({ commit }, data) {
    commit('updateCajaForm', data)
  },
}

const getters = {
  sedeCajero(state) {
    return state.sedes.CAJERO
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
